import { apiSlice } from './apiSlice';
import { AGENCY_URL } from '../constants';

export const agencyAuthApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    agencyLogin: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/auth`,
        method: 'POST',
        body: data, // { email, password }
      }),
    }),

    // Step 2 of login: submit the 6-digit code emailed to the agency.
    // On success the backend issues the real agencyJwt + CSRF cookies and
    // returns the same user-info shape agencyLogin used to return directly.
    agencyVerifyOtp: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/verify-otp`,
        method: 'POST',
        body: data, // { email, otp }
      }),
    }),

    agencyLogout: builder.mutation({
      query: () => ({
        url: `${AGENCY_URL}/logout`,
        method: 'POST',
      }),
    }),

    agencyRequestPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/preset`,
        method: 'POST',
        body: data, // { email }
      }),
    }),

    agencyResetPassword: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/resetpass`,
        method: 'POST',
        body: data, // { email, password, resetToken }
      }),
    }),
  }),
});

export const {
  useAgencyLoginMutation,
  useAgencyVerifyOtpMutation,
  useAgencyLogoutMutation,
  useAgencyRequestPasswordResetMutation,
  useAgencyResetPasswordMutation,
} = agencyAuthApiSlice;
